import '.bw{height:100vh;}.ssr-plugin'
import '.dz{height:min(50rem, 90vh);}.ssr-plugin'
import { Authentication } from '@app/components/blocks/authentication/Authentication'
import { AuthTab } from '@app/components/blocks/authentication/authTabs'
import { pages } from '@app/util/links'
import { ClientOnly } from '@based/sdk'
import { styled } from 'inlines'
import { useEffect } from 'react'
import { useLocation, useSearchParams } from 'wouter'
import { useUserContext } from '@app/util/hooks/useUserContext'
import { PageSeo } from '@app/components/core/seo/PageSeo'
import { useTranslations } from '@i18n/useLanguage'

const sanitizeRedirectTo = (value: string | null | undefined): string => {
  // Allow only internal relative paths (consistent with values in pages from links.ts).
  // Rejects absolute URLs, protocol-relative (//...) and backslash variants (/\...).
  if (value && /^\/(?![/\\])/.test(value)) return value
  return pages.home
}

export const AuthPage = ({
  tab,
  redirectTo,
}: {
  tab: AuthTab
  redirectTo?: string
}) => {
  const [_, navigate] = useLocation()
  const { isAuthenticated, isLoading } = useUserContext()
  const [searchParams] = useSearchParams()
  const redirectToUrl = sanitizeRedirectTo(searchParams.get('redirectTo') ?? redirectTo)
  const t = useTranslations().app.auth

  useEffect(() => {
    if (isAuthenticated && !isLoading) {
      navigate(redirectToUrl)
    }
  }, [isAuthenticated, isLoading, navigate, redirectToUrl])

  return (
    <>
      <PageSeo
        pageTitle={tab === 'login' ? t.logIn : t.signUp}
        noindex
      />
      <ClientOnly>
      <div className="bw"
      >
        <div className="dz">
          <Authentication tab={tab} redirectTo={redirectToUrl} />
        </div>
      </div>
      </ClientOnly>
    </>
  )
}
